'use client'
import { Button } from '@/components/ui/Button'
import SimplePage, { SIMPLE_LINK } from '@/components/ui/SimplePage'
import { reportClientError } from '@/lib/tracking'
import Link from 'next/link'
import { useEffect } from 'react'

export default function Error({ error, reset }) {
  useEffect(() => {
    console.error(error)
    // The page readers see when a page breaks: report it (2026-10-23).
    reportClientError(error, 'page')
  }, [error])

  return (
    <SimplePage
      title="Something went wrong"
      lede="This page didn't load properly. Trying again usually fixes it."
    >
      <div className="mt-8">
        <Button onClick={() => reset()} fullWidth>
          Try again
        </Button>
      </div>
      <p className="mt-6 font-sans text-sm leading-relaxed text-muted-foreground">
        Or go back to{' '}
        <Link href="/" className={SIMPLE_LINK}>
          today&apos;s stories
        </Link>
        . If it keeps happening,{' '}
        <Link href="/contact-us" className={SIMPLE_LINK}>
          let us know
        </Link>
        .
      </p>
    </SimplePage>
  )
}
